import { render } from "./HeroArea.vue?vue&type=template&id=ca301054&scoped=true"
import script from "./HeroArea.vue?vue&type=script&lang=js"
export * from "./HeroArea.vue?vue&type=script&lang=js"

import "./HeroArea.vue?vue&type=style&index=0&id=ca301054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca301054"]])

export default __exports__